import { render } from "./Widgets.vue?vue&type=template&id=f8bf64b4"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"

import "./Widgets.vue?vue&type=style&index=0&id=f8bf64b4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__